import React, { useMemo } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

import { getStaticUrl } from "js/config";
import ProgressBar from "js/react/components/ProgressBar";

import { AiOnboardingSteps } from "../../AiOnboardingFlowConstants";

const Container = styled.div`
    display: flex;
    padding: 20px;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    align-self: stretch;

`;
const StepLabel = styled.div`
    color: #000;
    flex: 0 0 auto;
    white-space: nowrap;
    font-family: "Source Sans Pro";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 125%; 
    letter-spacing: -0.32px;
   
`;

const ProgressWrapper = styled.div`
    flex: 1 1 auto;
    min-width: 0;
`;

const LogoWrapper = styled.div`
    display: flex;
    align-items: center;

`;

const BeautifulLogo = styled.img`
    width: 100px;
`;

export default function FlowProgress({ step }: { step: AiOnboardingSteps }) {
    const { t } = useTranslation();
    const { prevProgress, progress } = useMemo(() => {
        const steps = Object.values(AiOnboardingSteps);

        const prevStepIndex = Math.max(0, steps.indexOf(step) - 1);
        const stepIndex = Math.min(steps.length, steps.indexOf(step) + 1);

        const prevProgress = (prevStepIndex / steps.length) * 100;
        const progress = (stepIndex / steps.length) * 100;

        return { prevProgress, progress };
    }, [step]);

    const { currentStepNumber, totalSteps } = useMemo(() => {
        const steps = Object.values(AiOnboardingSteps);
        const currentStepNumber = steps.indexOf(step) + 1;
        const totalSteps = steps.length;
        return { currentStepNumber, totalSteps };
    }, [step]);

    return (
        <Container>
            <StepLabel>
                {t("Step {{currentStepNumber}} of {{totalSteps}}", { currentStepNumber, totalSteps })}
            </StepLabel>
            <ProgressWrapper>
                <ProgressBar prevProgress={prevProgress} progress={progress} />
            </ProgressWrapper>
            <LogoWrapper>
                <BeautifulLogo src={getStaticUrl("/images/beautifulai-logos/beautifulai-logo.svg")} alt="Beautiful Logo" />
            </LogoWrapper>
        </Container>
    );
}
